import { combineReducers } from 'redux';
import * as sessionReducers  from './session.js'
import * as userReducers  from './users.js'
import * as errorReducers  from './errors.js'
import * as webinarReducers  from './webinars.js'
import * as subscriptionReducers  from './subscriptions.js'
import * as vimeoReducers from './vimeo.js'
import * as modalReduces from './modal.js'
import * as quizReduceres from './quiz.js'
import * as suggestionReducers from './suggestions.js'
import * as requestReducers from './requests.js'
import * as sponsorsReducers from './sponsors.js';

import { reduxReactRouter, routerStateReducer, ReduxRouter } from 'redux-router';

const rootReducer = combineReducers({
  ...sessionReducers,
  ...userReducers,
  ...errorReducers,
  ...webinarReducers,
  ...subscriptionReducers,
  ...vimeoReducers,
  ...modalReduces,
  ...quizReduceres,
  ...suggestionReducers,
  ...requestReducers,
  ...sponsorsReducers,
  router: routerStateReducer
});

export default rootReducer;



/** WEBPACK FOOTER **
 ** ./src/reducers/index.js
 **/